import { PTI_STATUS_INACTIVE } from '@/consts/pti'

/**
 * Nombre d'itération immobile attendu pour la calibration
 * @type {number}
 */
export const FALL_CALIBRATION_EXPECTED_IMMOBILITY_TIMES = 10

/**
 * Modèle de vibration pour la calibration z
 * @type {number[]}
 */
export const FALL_CALIBRATION_VIBRATION = [3000, 2000, 1000, 2000, 2000]

/**
 * Durée de la calibration PTI
 * @type {number}
 */
export const FALL_CALIBRATION_DURATION = _.sum(FALL_CALIBRATION_VIBRATION) + 2000

/**
 * Seuil d'accélération pour la détection de chute sur l'axe Z
 * @type {number} - Accélération
 */
export const FALL_DETECTION_Z_FALL = -5

/**
 * Différence entre deux dates pour la detection de chute
 * @type {number} - Différence
 */
export const FALL_DETECTION_MIN_DATE_DIFF = 150

/**
 * Seuil d'accélération pour la détection du relevage
 * @type {number} - Accélération
 */
export const FALL_DETECTION_Z_WAKE = 2

/**
 * Seuil d'accélération pour une personne qui marche
 * @type {number} - Accélération
 */
export const FALL_DETECTION_SPEED_WALK = 2

/**
 * Seuil de détection de la verticalité en degre
 * @type {number} - 90 + BETA > beta > 90 - BETA
 */
export const FALL_DETECTION_BETA = 30

/**
 * Angle minimum pour la detection de chute
 * @type {number} - Valeur angulaire
 */
export const FALL_STATUS_WAIT_MIN_ANGLE = 4

/**
 * Temps pour signaler une fausse alert
 * @type {number}
 */
export const FALL_DETECTION_FALL_CANCEL = process.env.DEV ? 20 : 60

export const FALL_STATUS_INACTIVE = PTI_STATUS_INACTIVE
export const FALL_STATUS_ACTIVE = { value: 'active', label: 'Actif' }
export const FALL_STATUS_CALIBRATION = { value: 'calibration', label: 'Calibration' }
export const FALL_STATUS_FALL = { value: 'fall', label: 'Chute détectée' }
export const FALL_STATUS_FALSE_CONFIRMATION = { value: 'false_confirmation', label: `Vérification de la chute` }
export const FALL_STATUS_WAIT_WAKE = { value: 'wait_wake', label: `En attente d'une tentative pour se relever` }
export const FALL_STATUS_VERTICAL = { value: 'vertical', label: `L'agent a regagné sa verticalité` }
export const FALL_STATUS_WAKE = { value: 'wake', label: `L'agent s'est relevé` }
export const FALL_STATUS_WALK = { value: 'walk', label: `L'agent marche` }
export const FALL_STATUS_RAS = { value: 'ras', label: `L'agent a déclaré un faux positif` }
export const FALL_STATUS_SENDING = { value: 'sending', label: 'Signalement en cours' }
export const FALL_STATUS_DESKTOP = {
  value: 'desktop',
  label: 'Cette fonctionnalité est indisponible sur un ordinateur'
}

export const FALL_STATUS_LIST = [
  FALL_STATUS_INACTIVE,
  FALL_STATUS_ACTIVE,
  // FALL_STATUS_CALIBRATION,
  FALL_STATUS_FALL,
  FALL_STATUS_FALSE_CONFIRMATION,
  FALL_STATUS_WAIT_WAKE,
  FALL_STATUS_VERTICAL,
  FALL_STATUS_WAKE,
  FALL_STATUS_WALK,
  FALL_STATUS_RAS,
  FALL_STATUS_SENDING,
  FALL_STATUS_DESKTOP
]
